/**
     * Scroll to Cart
     */
const salesBanner = $('#salesBanner');
const timeSensitiveBanner = $('#timeSensitiveBanner');

if ($(salesBanner).length) {
    let salesBannerHeight = Math.floor($('#salesBanner').outerHeight());

    if ($('#salesBanner').hasClass('isSticky')) {

        $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - salesBannerHeight
            }, 1000);
        });
    } else {
        $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        });
    }
} else if (timeSensitiveBanner.length) {
    $('#timeSensitiveBanner, .btn:not(.cta)').on('click', function (event) {
        let timeSensitiveBannerHeight = Math.floor($('#timeSensitiveBanner').outerHeight());

        if ($('body').hasClass('show-timeSensitiveBanner')) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - timeSensitiveBannerHeight
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        }
    });

} else {
    $('.btn:not(.cta), #giveAwayBanner').on('click', function (event) {
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
        }, 1000);
    });
}

// Add alert 
$('.cta-wrap').on('click', function () {
    if ($('#cartCta').hasClass('disabled')) {
        $(".subscribe-box__alert").addClass('show');
        $("#subscribeCheckbox").addClass('alert');
    }
})

/**
 * Handle products
 */
const
    body = $('body'),
    disclaimerBox = $('#disclaimerBox'),
    disclaimerTrigger = $('#disclaimerTrigger'),
    subscribeMode = $('.purchaseMode'),
    subscribeModeDoubleSS = $('#subscribeModeDoubleSS');

//- Select Subscribe option if click on disclaimer box title
disclaimerTrigger.on("click", function () {
    let checkbox = $('#subscribeCheckbox');
    let cartBtn = $('#cartCta');

    checkbox.toggleClass('checked');
    cartBtn.toggleClass('disabled');

    if (checkbox.hasClass('alert')) {
        $('.subscribe-box__alert').removeClass('show');
        checkbox.removeClass('alert');
    }
});

// close disclaimer box
$('#closeDisclaimer').on('click', function () {
    disclaimerBox.removeClass('subscribe-box__disclaimer--open');
});

// Select Product Option - extended functionality to switch between products
$('.product-switch__option').on('click', function () {
    let thisProduct = $(this);
    let thisProductAttr = thisProduct.attr('data-product-option');

    if (!thisProduct.hasClass('active')) {
        $('.product-switch__option').removeClass('active');
        thisProduct.addClass('active');
    }

    //- assign the chosen product attr to its parent
    thisProduct.parent().attr('data-product', thisProductAttr);

    $('.cart__product.active').trigger("click");
})

// Subscribe Mode
$('.subscribe-box__default').on('click', function () {
    let thisBtn = $(this);
    let cartBtn = $('#cartCta');
    let checkbox = $('#subscribeCheckbox');

    $('.subscribe-box__default').removeClass('active');
    thisBtn.addClass('active');

    disclaimerBox.addClass('subscribe-box__disclaimer--open');

    //- reset all UIs
    if (cartBtn.hasClass('disabled')) {
        cartBtn.removeClass('disabled');
    }

    if (checkbox.hasClass('checked')) {
        checkbox.removeClass('checked');
    }

    //- set 'data-subscribe' value + control UI
    if (thisBtn.hasClass('subscribe')) {
        subscribeMode.attr('data-subscribe', 'true');

        if (!cartBtn.hasClass('disabled')) {
            cartBtn.addClass('disabled');
        }

        if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.addClass('subscribe-box__disclaimer--open');
        }

    } else {
        subscribeMode.attr('data-subscribe', 'false');

        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }

    $('.cart__product.active').trigger("click");
});

/**
 * Subscribe Mode - chechbox mode
 */
$('#subscribeInput').on('click', function (check) {
    // console.log($(this).is(":checked"));

    let checkboxType;

    if ($('#orderNow').attr('data-subscribe') === 'false') {
        checkboxType = true;

        subscribeOn();

        if (ctaSubscribeAndSaveText != '') {
            $('#cartCta').html(ctaSubscribeAndSaveText);
        }

        if (subscribeModeDoubleSS.length) {
            $('#cartCta').addClass('disabled');
        }

    } else {
        checkboxType = false;

        subscribeOff();

        if (ctaSubscribeAndSaveText != '') {
            const htmlToRender = promotionText != '' ? `${ctaText}<span class='cta-btn__promoText'>${promotionText}</span>` : ctaText;
            $('#cartCta').html(htmlToRender);
        }

        if (subscribeModeDoubleSS.length) {
            $('#cartCta').removeClass('disabled');

            //- Reset S&S click on disable alert
            if ($('#subscribeCheckbox').hasClass('alert')) {
                $(".subscribe-box__alert").removeClass('show');
                $("#subscribeCheckbox").removeClass('alert');
            }

            if ($('#subscribeCheckbox').hasClass('checked')) {
                $("#subscribeCheckbox").removeClass('checked');
            }
        }
    }

    this.setAttribute('checked', checkboxType);

    $('.cart__product.active').trigger("click");
});

$('#stateSSOn').on('click', function (check) {
    subscribeOn();

    $('#subscribeInput').attr('checked', 'true');

    $('.cart__product.active').trigger("click");
})

function subscribeOn() {
    $('#orderNow').attr('data-subscribe', 'true');
    subscribeMode.attr('data-subscribe', 'true');
    disclaimerBox.addClass('subscribe-box__disclaimer--open');
}

function subscribeOff() {
    $('#orderNow').attr('data-subscribe', 'false')
    subscribeMode.attr('data-subscribe', 'false');

    // on touch screens
    if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    }
}

function activeProduct() {
    let thisProduct = $(this);
    let subscribeAttr = $('.purchaseMode').attr('data-subscribe');
    let chooseProductAttr = $('#chooseProduct').attr('data-product');

    const retail = thisProduct.attr('data-retail');

    let price,
        regularity,
        link,
        shipping,
        alternativeContentValue,
        timeSensitiveBannerContentValue,
        badge,
        timeSensitiveBanner,
        unit = thisProduct.attr('data-units'),
        extraSavingsText = thisProduct.attr('data-extra-savings-text');

    if (thisProduct.attr('data-stamp')) {
        badge = thisProduct.attr('data-stamp');
    }

    if ($('#chooseProduct').length && chooseProductAttr === 'optional') {
        if (subscribeAttr === 'true') {
            link = 'data-option-subscribe-tracker';

        } else {
            link = 'data-option-tracker';
        }

        $('.cart__image-default').removeClass('show').addClass('hide');
        $('.cart__image-optional').removeClass('hide').addClass('show');

    } else {
        if (subscribeAttr === 'true') {
            link = 'data-subscribe-tracker';

        } else {
            link = 'data-tracker';
        }$(body).hasClass

        $('.cart__image-default').removeClass('hide').addClass('show');
        $('.cart__image-optional').removeClass('show').addClass('hide');
    }

    if (subscribeAttr === 'true') {
        price = 'data-subscribe-amount';
        regularity = '<span>/month</span>';
        shipping = 'data-subscribe-shipping';
        alternativeContentValue = '';

        // $('.current__value').html(thisProduct.attr(price) + '<span>/month</span>');

    } else {
        price = 'data-amount';
        regularity = '';
        shipping = 'data-shipping';
        alternativeContentValue = $('#alternativeContent').attr('data-alt-content');

        // $('.current__value').html(thisProduct.attr(price));
    }

    if ($(body).hasClass('show-timeSensitiveBanner')) {
        timeSensitiveBanner = '-timeSensitiveBanner';
        timeSensitiveBannerContentValue = $('#timeSensitiveBannerContent').attr('data-time-sensitive-content');
        shipping = 'data-shipping-time-sensitive';

        $('.extra-data__img .icon--timeSensitive').each(function(){
            const timeSensitiveImage = $(this).data('time-sensitive-image');
            const timestamp = $(this).data('timestamp');
            $(this).html(`<use xlink:href="svg/sprite.svg?rel=${timestamp}#${timeSensitiveImage}"></use>`);
        });
    } else {
        timeSensitiveBanner = ''
        timeSensitiveBannerContentValue = $('#timeSensitiveBannerContent').attr('data-time-sensitive-content-off');
        
        $('.extra-data__img .icon--timeSensitive').each(function(){
            const regularImage = $(this).data('image');
            const timestamp = $(this).data('timestamp');
            $(this).html(`<use xlink:href="svg/sprite.svg?rel=${timestamp}#${regularImage}"></use>`);
        });
    }

    $('.cart__product').removeClass('active');
    thisProduct.addClass('active');

    //- Support to animate 
    if ($('#productSwitch').length) {
        $('#productSwitch').removeClass(function (index, className) {
            return (className.match(/(^|\s)unit\S+/g) || []).join(' ');
        }).addClass('unit' + unit);
    }

    $('.current__value').html(thisProduct.attr(price) + regularity);
    $('.retail__value').html(retail);
    $('.shipping__value').html((thisProduct.attr(shipping)));

    if($('.cart__summary--timeSensitive').length) {
        let timeSensitiveShipping = thisProduct.attr(shipping),
            timeSensitiveShippingFirstChar = timeSensitiveShipping.charAt(0),
            timeSensitiveShippingRemoveFirstChar = timeSensitiveShipping.substring(1);

        if(timeSensitiveShippingFirstChar == '-') {
            $('.shipping__value').addClass('shipping__value--neg');

        } else {
            $('.shipping__value').removeClass('shipping__value--neg');
        }

        $('.shipping__value').html(timeSensitiveShippingRemoveFirstChar);
        
    } else {
        $('.shipping__value').html((thisProduct.attr(shipping)) + ' ');
    }

    $('#alternativeContent').html(' ' + alternativeContentValue);

    //- When time sensitive banner promo
    $('#timeSensitiveBannerContent').html(timeSensitiveBannerContentValue);

    //- TECH-2164 - Remove Shipping
    // if (unit == '3' || unit == '6' || unit == '1' && subscribeAttr === 'true') {
    //     if (!$('.shipping').hasClass('hide')) {
    //         $('.shipping').addClass('hide');
    //     }
    // } else {
    //     $('.shipping').removeClass('hide');
    // }

    $('.saving__value').html((retail - thisProduct.attr(price)).toFixed(2));
    $('.saving__extra-text').html(extraSavingsText);

    // Images to show according to the product unit
    $('.cart__image-item').removeClass('show').addClass('hide');
    $('.cart__image-item--' + unit + "").removeClass('hide').addClass('show');

    //- prints Best value per package
    if ($('#ribbon').length) {
        $('.ribbon__value').html(badge);
    }

    //- handle CTA by ID
    adjustUtmContent();

    let param = $('#cartCta').attr('data-param');
    $('#cartCta').attr('href', thisProduct.attr(link + timeSensitiveBanner) + param);
}

$('.cart__product').on('click', activeProduct);
$('.cart__product.active').trigger("click");

/**
 * product Images Carousel Slick
 */
if ($('.style1 #productImagesCarousel').length) {
    $('#productImagesCarousel').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        adaptiveHeight: false,
        centerMode: false,
        infinite: true
    });
}
if ($('.style2 #productImagesCarousel').length) {
    $('#productImagesCarousel').slick({
        slidesToShow: 1,
        arrows: false,
        dots: false,
        speed: 700,
        autoplay: true,
        autoplaySpeed: 4000,
        adaptiveHeight: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true
                }
            }
        ]
    });
}


// Play - Pause btn
$('.pauseBtns .pause').on('click', function () {
    $('.pauseBtns .pause').removeClass('show').addClass('hide');
    $('.pauseBtns .play').removeClass('hide').addClass('show');
    $('.style2 #productImagesCarousel')
        .slick('slickPause')
});

$('.pauseBtns .play').on('click', function () {
    $('.pauseBtns .play').removeClass('show').addClass('hide');
    $('.pauseBtns .pause').removeClass('hide').addClass('show');
    $('.style2 #productImagesCarousel')
        .slick('slickPlay')
});

//- handle Modal > load / show correct image
$('#imageModal').on('show.bs.modal', function (event) {
    let eventTrigger = $(event.relatedTarget); // Button that triggered the modal
    let mediaSrc = eventTrigger.attr('src'); // Extract img src
    let mediaAlt = eventTrigger.attr('alt'); // Extract info from data-* attributes

    let modal = $(this)

    $('body').addClass('productImagesCarousel');
    modal.find('.modal-body img').attr("src", mediaSrc).attr("alt", mediaAlt);
});

$('#imageModal').on('hidden.bs.modal', function (event) {
    $('body').removeClass('productImagesCarousel');
});